<template>
  <div class="toast-wrapper" @click.self="close">
    <div class="toast-container">
      <div class="toast">
        <p><slot></slot></p>
        <span role="button" class="toast-close" @click="close">
          <IcFalse class="icn lg"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SPBasicToast',

  data() {
    return {
      count: this.$store.state.common.toast.time,
      timer: null
    }
  },

  watch: {
    count(newVal) {
      if (newVal === 0) {
        this.close()
      }
    }
  },

  methods: {
    close() {
      this.$store.dispatch('common/hideToast')
      this.resetTimer()
    },
    resetTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },

  mounted() {
    this.timer = setInterval(() => {
      this.count--
    }, 1000)
  },

  beforeDestroy() {
    this.resetTimer()
  }
}
</script>

<style lang="scss" scoped>
.toast-wrapper {
  position: fixed;
  z-index: $index-popup;
  background-color: rgba(0,0,0,.1);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .toast-container {
    position: absolute;
    width: calc(100% - 20px);
    top: 16px;
    left: 0;
  }
  .toast {
    background-color: #fff;
    font-size: 1.6rem;
    padding: 12px 52px 12px 12px;
    border-radius: 0 4px 4px 0;
    color: $color-content;
    &-close {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translate3d(0,-50%,0);
      .icn {
        color: $color-sup;
        font-size: 1.6rem;
      }
    }
  }
}
</style>
